import { render, staticRenderFns } from "./veStuGraduationYyxsShow.vue?vue&type=template&id=90a25100&scoped=true"
import script from "./veStuGraduationYyxsShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYyxsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a25100",
  null
  
)

export default component.exports